




















































































































































































import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import CrudStepsNavBar from '@/reusable/Mantenedor/CrudStepsNavBar.vue';
import { PasosCrud } from '@/reusable/Mantenedor/mantenedorUtils';
import ContenidoModal from '@/reusable/Modal/ContenidoModal.vue';
import config from '@/config/index';
import { Mensaje } from '@/pantallas/CopilotoVirtual/Mensaje/mensaje';
import TextField from '@/reusable/Form/TextField.vue';
import { fetchReportesSerie } from './fetchReporteSerie';
import { Funcionalidades } from '@/config/funcionalidades';

@Component({
  components: {
    CabeceraModal,
    ModalMantenedor,
    CrudStepsNavBar,
    ContenidoModal,
    TextField,
    FormFieldsContainer,
  },
})
export default class VerEditarModal extends Vue {
  @Prop({ default: true }) show: boolean;
  @Prop({ default: null }) id: any;
  @Prop({ default: null }) nombre: any;
  @Prop({ default: null }) apellido: any;
  @Prop({ default: null }) email: any;
  @Prop({ default: null }) direccion: any;
  @Prop({ default: null }) tel: any;
  @Prop({ default: null }) localidad: any;
  @Prop({ default: null }) bodega: any;
  @Prop({ default: null }) tipoubicaid: any;
  @Prop({ default: null }) locaid2: any;
  @Prop({ default: null }) estado: any;
  @Prop({ default: null }) rut: any;

  mensajes: Mensaje[] = [];
  localidadeslist: any[] = [];
  bloquear: boolean = false;
  dictionaryFormErrors: any = {};
  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();
  readonly funcionalidad: Funcionalidades = Funcionalidades.AltaTecnico;

  pasoActivoIndex = 1;
  readonly pasos: PasosCrud = {
    requerimiento: {
      accion: 'Editar Técnico',
      visible: true,
      step: 1,
      title: 'Editar Técnico',
      icon: 'ballot',
      formState: {
        entity: null,
        validator: null,
        isDirty: false,
      },
    },
  };

  async verificar_rut() {
    return fetchReportesSerie(
      {
        id: this.formFields.id.value,
        rut: this.formFields.rut.value
          .toString()
          .split('.')
          .join(''),
      },
      'AltaTecnico/verificar_rut'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.data.exists;
        } else {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        this.$snotify.error('Ocurrió un error al verificar el rut', {
          timeout: 3000,
        });
      });
  }

  respuesta: any;
  locaidsend: any;
  async editar2() {
    let self = this;
    let rutDisponible = await this.verificar_rut();
    if (rutDisponible == 't' && this.formFields.rut.value != '') {
      self.$snotify.error('El rut ya se encuentra registrado', {
        timeout: 3000,
      });
      return;
    }

    this.respuesta = await this.$validator.validateAll();

    this.loadingService.showLoading();
    this.locaidsend = this.formFields.localidad.value;
    if (this.respuesta == false) {
      self.$snotify.error('Por favor ingrese los campos requeridos.', {
        timeout: 3000,
      });
      this.loadingService.hideLoading();
      return;
    }
    return fetchReportesSerie(
      {
        usuarioid_modifica: JSON.parse(localStorage.getItem('user')).id,
        usuariorut_modifica: JSON.parse(localStorage.getItem('user'))
          .rutClienteDefecto,
        tecnicoid: this.formFields.id.value,
        tecniconame: this.formFields.nombre.value.toString().toUpperCase(),
        tecnicodireccion: this.formFields.direccion.value
          .toString()
          .toUpperCase(),
        tecnicomail: this.formFields.email.value.toString().toUpperCase(),
        tecnicotel: this.formFields.tel.value,
        locaid: this.locaidsend.locaid,
        tipoubicaid: this.tipoubicaid,
        tipoubicaname: this.formFields.ubicacion.value.toString().toUpperCase(),
        apellido: this.formFields.apellido.value.toString().toUpperCase(),
        modulo: this.funcionalidad,
        estado: this.formFields.estado.value,
        cambioEstado: this.estadoInicial !== this.formFields.estado.value,
        rut: this.formFields.rut.value
          .toString()
          .split('.')
          .join(''),
      },
      'AltaTecnico/update_tecnico'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.success(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.handleCerrar();
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  estados: any = ['ACTIVO', 'INACTIVO'];

  formFields: FormFieldDefMap = {
    id: {
      label: 'Id',
      id: this.id,
      value: this.id,
    },
    nombre: {
      label: 'Nombre',
      id: this.nombre,
      value: this.nombre,
    },
    apellido: {
      label: 'Apellido',
      id: this.apellido,
      value: this.apellido,
    },
    direccion: {
      label: 'Dirección',
      id: this.direccion,
      value: this.direccion,
    },
    email: {
      label: 'Email',
      id: this.email,
      value: this.email,
    },
    tel: {
      label: 'Teléfono',
      id: this.tel,
      value: this.tel,
    },
    localidad: {
      label: 'Localidad',
      id: '',
      value: '',
    },
    ubicacion: {
      label: 'Ubicación',
      id: this.bodega,
      value: this.bodega,
    },
    rut: {
      label: 'Rut',
      id: this.rut,
      value: this.rut,
    },
    estado: {
      label: 'Estado',
      id: '',
      value: '',
    },
  };

  rules = {
    required: (value: any) => !!value || 'Required.',
    rut: (value: any) => {
      let Fn = {
        // Valida el rut con su cadena completa "XXXXXXXX-X"
        validaRut: function(rutCompleto: any) {
          rutCompleto = rutCompleto.replace('‐', '-').replace(/[.]/g, '');
          if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(rutCompleto)) return false;
          var tmp = rutCompleto.split('-');
          var digv = tmp[1];
          var rut = tmp[0];
          if (digv == 'K') digv = 'k';

          return Fn.dv(rut) == digv;
        },
        dv: function(T: any) {
          var M = 0,
            S = 1;
          for (; T; T = Math.floor(T / 10))
            S = (S + (T % 10) * (9 - (M++ % 6))) % 11;
          return S ? S - 1 : 'k';
        },
      };
      return Fn.validaRut(value) || 'Rut Invalido';
    },
  };

  async getEquipos() {
    let self = this;
    this.loadingService.showLoading();
    return fetchReportesSerie({ '': '' }, 'AltaTecnico/get_localidades')
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.localidadeslist = data.data.LOCALIDAD;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  estadoInicial: string;
  mounted() {
    if (this.estado != 'Activo') {
      this.bloquear = true;
      this.formFields.estado.value = 'INACTIVO';
    } else {
      this.formFields.estado.value = 'ACTIVO';
    }
    this.estadoInicial = this.formFields.estado.value;
    this.getEquipos();
    this.formFields.localidad.value = {
      locaname: this.localidad,
      locaid: this.locaid2,
    };
    this.dictionaryFormErrors = {
      custom: {
        rut: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
          regex: () => config.errorMensajes.regex,
        },
        name: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
          alpha_spaces: () =>
            '* El campo Nombre solo debe contener letras y/o espacios.',
        },
        lastname: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
          alpha_spaces: () =>
            '* El campo Apellido solo debe contener letras y/o espacios.',
        },
        ubicacion: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
        },
        localidad: {
          required: () => config.errorMensajes.textoRequerido,
        },
        apellidoPaterno: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
          alpha_spaces: () =>
            '* El campo Apellido Paterno solo debe contener letras y/o espacios.',
        },
        apellidoMaterno: {
          max: () => config.errorMensajes.maxLength,
          alpha_spaces: () =>
            '* El campo Apellido Materno solo debe contener letras y/o espacios.',
        },
        email: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
        },
        contrasena: {
          required: () => config.errorMensajes.textoRequerido,
          confirmed: () => config.errorMensajes.passNoIguales,
          min: () => 'El campo debe tener al menos 8 caracteres.',
        },
        direccion: {
          max: () => config.errorMensajes.maxLength,
        },
        telefonoFijo: {
          max: () => config.errorMensajes.maxLength,
        },
        celular: {
          max: () => config.errorMensajes.maxLength,
          regex: () => config.errorMensajes.regex,
        },
        estado: {
          required: () => config.errorMensajes.textoRequerido,
        },
        fechaNacimiento: {
          mayorDeEdad: () => config.errorMensajes.fechaMayoriaEdad,
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
        },
      },
    };
    this.$validator.localize('es', this.dictionaryFormErrors);
  }
  @Watch('ReporteSeleccionado')
  handleRutasSeleccionadas() {
    return;
  }

  handleCerrar() {
    this.$emit('cerrar');
  }
}
